import React from 'react';

import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { TableScreenWithoutUpdate } from '../blocks/table_block';
import { ENT_TYPES, PROJECT_PREFIX, STATUSES } from '../const';
import { formatDateTime } from '../tools/converters';

export default class PocketsQuasisection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            entity_alias: ENT_TYPES[5].id,
            entity: {
                id: '', name: '', slug: '', alt_name: '',
            },
            is_update: false,
            project: props.match.params.project,
            endpoint: `v4/${props.match.params.project}/story/?`,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.project !== this.props.match.params.project) {
            this.setState({
                project: this.props.match.params.project,
                endpoint: `v4/${this.props.match.params.project}/story/?`,
            });
        }
    }

    columns = [
        {
            Header: 'Тип материала',
            sortable: false,
            accessor: 'type',
            maxWidth: 100,
            headerClassName: 'wordwrap',
        }, {
            Header: 'Название',
            accessor: 'title',
            minWidth: 440,
            Cell: (row) => (
                <div>
                    <Link to={`${PROJECT_PREFIX}/${this.state.project}/story/${row.original.type}/${row.original.id}/edit`}>
                        {row.original.title}
                    </Link>
                </div>
            ),
        }, {
            Header: 'Статус',
            accessor: 'status',
            maxWidth: 160,
            Cell: (row) => (
                <span>
                    <span style={{
                        color: STATUSES[row.value].color,
                        transition: 'all .3s ease',
                    }}
                    >
                        &#x25cf;
                        &nbsp;
                    </span>
                    {STATUSES[row.value].label}
                </span>
            ),
        }, {
            Header: 'Дата добавления',
            accessor: 'created_at',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Дата изменения',
            accessor: 'modified_at',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Дата публикации',
            accessor: 'date_published',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Просм.',
            accessor: 'views',
            maxWidth: 70,
        },
    ];

    render() {
        return (
            <div className="container-fluid">
                <Row>
                    <Col md={12}>
                        <TableScreenWithoutUpdate
                            key={`${this.state.project}-${this.props.section}`}
                            columns={this.columns}
                            endpoint={`${this.state.endpoint}tag=${this.props.section}`}
                            data={this.state}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}
